// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","293":"component---src-pages-index-js","432":"component---src-pages-about-js"}[chunkId] || chunkId) + "-" + {"108":"d35ce678044a67f6831d","223":"2fd6e2e35cd282e520c1","293":"0bfd8541da3e09af21a3","432":"307265ab11d922b94ecb","452":"f8598c298826faf0df80"}[chunkId] + ".js";
};